import { Grid, Stack, Typography } from "@mui/material";
import { OssPanel } from "../common/OssPanel";

const cards = [
  ["totalLines", "전체 품목"],
  ["checkRequired", "확인 필요"],
  ["changeReview", "변경 검토"],
  ["deliveryRisk", "납기 위험"],
  ["planNotApplied", "계획 미반영"],
  ["completed", "완료"],
];

export const OssReportSummary = ({ summary = {} }) => (
  <Grid container spacing={1}>
    {cards.map(([key, label]) => (
      <Grid item xs={6} md={2} key={key}>
        <OssPanel sx={{ p: 1.6, minHeight: 92 }}>
          <Stack spacing={0.6}>
            <Typography sx={{ color: "#64748b", fontSize: 13 }}>{label}</Typography>
            <Typography sx={{ color: "#111827", fontSize: 28, fontWeight: 900, lineHeight: 1 }}>
              {summary[key] || 0}
              <Typography component="span" sx={{ ml: 0.4, fontSize: 13, color: "#475569" }}>
                건
              </Typography>
            </Typography>
          </Stack>
        </OssPanel>
      </Grid>
    ))}
  </Grid>
);
